const ACCOUNT_QUERY_KEYS = "account";

export const accountQueryKeys = {
  all: [ACCOUNT_QUERY_KEYS] as const,
  me: function me() {
    return [ACCOUNT_QUERY_KEYS, "me"] as const;
  },
};
